import { onPageIn, onMount, onDestroy } from '@/modules/_'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  let resizeHandler: (() => void) | null = null
  let observer: IntersectionObserver | null = null

  function processIdentityLayout() {
    // Check if screen width is above mobile landscape (765px)
    if (window.innerWidth <= 765) {
      // Remove all applied styles on mobile
      removeIdentityLayoutStyles()
      return
    }

    // Find all parents with identity_layout class
    const identityLayouts = element.querySelectorAll('.identity_layout')

    identityLayouts.forEach((parent) => {
      // Apply dense grid packing to fix overlapping issue
      ;(parent as HTMLElement).style.gridAutoFlow = 'row dense'

      // Find all children with columnsize attribute
      const elementsWithColumnSize = parent.querySelectorAll('[columnsize]')

      elementsWithColumnSize.forEach((el) => {
        const columnSize = el.getAttribute('columnsize')

        if (columnSize && columnSize.includes('/')) {
          // Split the columnsize value by '/'
          const [start, span] = columnSize.split('/')

          // Apply grid-column CSS
          ;(
            el as HTMLElement
          ).style.gridColumn = `${start.trim()} / span ${span.trim()}`
        }
      })

      // Find all children with aspectratio attribute
      const elementsWithAspectRatio = parent.querySelectorAll('[aspectratio]')

      elementsWithAspectRatio.forEach((el) => {
        const aspectRatio = el.getAttribute('aspectratio')

        if (aspectRatio) {
          // Convert format like "4:3" to "4/3" for CSS aspect-ratio
          const cssAspectRatio = aspectRatio.replace(':', '/')

          // Apply aspect-ratio CSS
          ;(el as HTMLElement).style.aspectRatio = cssAspectRatio
        }
      })
    })
  }

  function removeIdentityLayoutStyles() {
    const identityLayouts = element.querySelectorAll('.identity_layout')

    identityLayouts.forEach((parent) => {
      ;(parent as HTMLElement).style.gridAutoFlow = ''

      const elementsWithColumnSize = parent.querySelectorAll('[columnsize]')
      elementsWithColumnSize.forEach((el) => {
        ;(el as HTMLElement).style.gridColumn = ''
      })

      const elementsWithAspectRatio = parent.querySelectorAll('[aspectratio]')
      elementsWithAspectRatio.forEach((el) => {
        ;(el as HTMLElement).style.aspectRatio = ''
      })
    })
  }

  function initializeOverlayObserver() {
    const mediaWraps = element.querySelectorAll('.identity_media_wrap')

    if (mediaWraps.length === 0) return

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const mediaWrap = entry.target as HTMLElement
          const overlay = mediaWrap.querySelector(
            '.identity_media_overlay'
          ) as HTMLElement

          if (overlay) {
            if (!overlay.style.transition) {
              overlay.style.transition = 'opacity 0.8s ease-in-out'
            }

            if (entry.isIntersecting) {
              overlay.style.opacity = '0'
            } else {
              overlay.style.opacity = '1'
            }
          }
        })
      },
      {
        threshold: 1,
        rootMargin: '0px',
      }
    )

    mediaWraps.forEach((wrap) => {
      observer?.observe(wrap)
    })
  }

  onMount(() => {
    processIdentityLayout()

    initializeOverlayObserver()

    resizeHandler = () => {
      processIdentityLayout()
    }

    window.addEventListener('resize', resizeHandler)
  })

  onDestroy(() => {
    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler)
    }

    if (observer) {
      observer.disconnect()
      observer = null
    }

    removeIdentityLayoutStyles()
  })
}
